"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const forgot_password_1 = require("@Entities/schemas/user/forgot-password");
const zod_1 = require("@hookform/resolvers/zod");
const FormFieldFromProps_1 = __importDefault(require("@App/kit/fields/v2/FormFieldFromProps"));
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const CollectEmailStep = (props) => {
    const { authStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { setEmailAddress } = props;
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        const username = data.username;
        yield authStore.forgotPassword(username);
        setEmailAddress(username);
        preloaderStore.openTransparentPreloader(false);
    });
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        delayError: 750, // MilliSeconds: this delay is here so email validation doesn't start when user starts typing
        resolver: (0, zod_1.zodResolver)(forgot_password_1.emailSchema),
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h3", { className: "with-subtitle" }, "Forgot password"),
        react_1.default.createElement("div", { className: "subtitle" }, "Enter the email address associated with your account."),
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
            react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit) },
                react_1.default.createElement(FormFieldFromProps_1.default, { field: forgot_password_1.emailFormFields.username }),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', icon: common_1.ICONS.arrow_forward, submitType: 'submit', disabled: !methods.formState.isValid }, "Send Recovery Code")))));
};
exports.default = (0, mobx_react_1.observer)(CollectEmailStep);
